var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".app[data-v-75401ed9]{background-color:#eef2f5;padding-bottom:3.75rem}.app .user-list li[data-v-75401ed9]{height:2.25rem;line-height:2.25rem;padding:0 .5rem;display:flex;justify-content:space-between;border-bottom:.025rem solid #eef2f5;background-color:#fff;overflow:hidden}.app .user-list li[data-v-75401ed9]:before{position:absolute;content:\"\";height:.7rem;width:.4rem;top:.7rem;right:.55rem;background-image:url(" + escape(require("../../../static/img/more-arrow.png")) + ");background-size:100% 100%}.app .ok-wrap[data-v-75401ed9]{padding:0 .5rem;margin-top:.5rem}.app .ok-wrap .btn-ok[data-v-75401ed9]{letter-spacing:.026667rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-75401ed9","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/modules/hospitalPage/HealthySichuanMyRegister.vue
// module id = 470
// module chunks = 0